import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';

import TermsAndConditions from '../../../TermsAndConditions';
import InvitationListItem from '../InvitationListItem';
import { getFullName } from '../../utils';
import Loader from '../../../common/Loader';
import Popup from '../../../common/Popup';
import Shape from '../../../common/Shape';
import Button from '../../../Button';
import { enhance } from './enhance';

function InvitationDetailsPopup({
  onClose,
  invitation,
  getOptions,
  loggedUser,
  intl: { formatMessage },
}) {
  const [valid, setValidity] = useState(false);
  const title = formatMessage({ id: 'healthboard.invitations.modal.title' });
  const country = get(loggedUser, 'country');
  const inviteId = get(invitation, 'id');
  const name = getFullName(get(invitation, 'targetUser'));
  const { renderInfo, accept, decline, pending } = getOptions();

  const handleAccept = () =>
    accept({ termsAndConditionsAccepted: true, id: inviteId });

  const handleDecline = () => decline({ id: inviteId });

  useEffect(() => {
    if (!invitation) {
      setValidity(false);
    }
  }, [invitation]);

  return (
    <Popup
      strictClose
      opened={Boolean(invitation)}
      onClose={onClose}
      title={title}
      width="auto"
      autoHeight
    >
      <div styleName="root">
        <InvitationListItem
          styleName="header"
          formatMessage={formatMessage}
          invitation={invitation}
        />
        <Shape styleName={cn('content', { pending })}>
          {pending && <Loader styleName="loader" />}

          <div styleName="details">
            <div styleName="info">
              <span styleName="invitator">{name}</span>
              {renderInfo()}
            </div>

            <div styleName="terms">
              <TermsAndConditions
                onSelect={checked => setValidity(checked)}
                country={country}
                hasSeparator
                acceptable
              />
            </div>

            <div>
              <Button
                onClick={handleAccept}
                disabled={!valid}
                color="primary"
                className="mr3"
                raised
              >
                {formatMessage({ id: 'common.accept' })}
              </Button>
              <Button color="accent" raised onClick={handleDecline}>
                {formatMessage({ id: 'common.decline' })}
              </Button>
            </div>
          </div>
        </Shape>
      </div>
    </Popup>
  );
}

InvitationDetailsPopup.propTypes = {
  onClose: PropTypes.func,
  getOptions: PropTypes.func,
  invitation: PropTypes.object,
  loggedUser: PropTypes.object,
  intl: PropTypes.object,
};

export default enhance(InvitationDetailsPopup);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InvitationDetailsPopup/index.jsx